import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";
import React, { useEffect, useState } from "react";
import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import "../../assets/styles/Calendar.css"; // Custom styles for highlighting deadlines
import jalaali from "jalaali-js";

function TaskCalendar({ tasks, selectedTask, onDayClick }) {
	const [selectedTaskDeadline, setSelectedTaskDeadline] = useState(null);
	const [selectedDay, setSelectedDay] = useState(null);

	useEffect(() => {
		if (selectedDay) {
			onDayClick(selectedDay);
		}
	}, [selectedDay]);

	useEffect(() => {
		if (selectedTask) {
			const task = tasks.find((t) => t.id === selectedTask);
			if (task && task.deadline) {
				const parsedDate = parseDate(task.deadline);
				setSelectedTaskDeadline(parsedDate);
			} else {
				setSelectedTaskDeadline(null);
			}
		} else {
			setSelectedTaskDeadline(null);
		}
	}, [selectedTask, tasks]);

	const parseDate = (dateString) => {
		try {
			if (!dateString) {
				throw new Error("Invalid date");
			}
			const date = new Date(dateString);
			if (isNaN(date.getTime())) {
				throw new Error("Invalid date");
			}
			const shamsiDate = jalaali.toJalaali(date);
			return {
				year: shamsiDate.jy,
				month: shamsiDate.jm,
				day: shamsiDate.jd,
			};
		} catch (error) {
			return null;
		}
	};

	const deadlines = tasks
		.map((task) => {
			if (task.deadline) {
				const parsedDate = parseDate(task.deadline);
				return parsedDate;
			}
			return null;
		})
		.filter((date) => date !== null);

	const renderCustomDay = (day) => {
		const isDeadline = deadlines.some(
			(deadline) =>
				deadline.year === day.year &&
				deadline.month === day.month &&
				deadline.day === day.day,
		);
		const isSelectedTaskDeadline = selectedTaskDeadline
			? selectedTaskDeadline.year === day.year &&
				selectedTaskDeadline.month === day.month &&
				selectedTaskDeadline.day === day.day
			: false;

		if (isSelectedTaskDeadline) {
			return (
				<div className="highlight-selected">
					<span>{day.day}</span>
				</div>
			);
		} else if (isDeadline) {
			return (
				<div className="highlight">
					<span>{day.day}</span>
				</div>
			);
		}
		return <span>{day.day}</span>;
	};

	return (
		<div style={{ height: "fit-content" }}>
			<Calendar
				value={selectedTaskDeadline} // Conditionally set the value prop
				onChange={setSelectedDay}
				customDaysClassName={deadlines.map((deadline) => ({
					year: deadline.year,
					month: deadline.month,
					day: deadline.day,
					className: "highlight",
				}))}
				renderDay={renderCustomDay}
				locale="fa" // Set the locale to Persian
				shouldHighlightWeekends
			/>
		</div>
	);
}

export default TaskCalendar;
